import {useEffect} from "react";

export const useRecaptcha = (googleRecaptchaKey) => {
    useEffect(() => {
        // eslint-disable-next-line no-undef
        if (document.contains(document.getElementById("recaptcha"))) {
            // eslint-disable-next-line no-undef
            document.getElementById("recaptcha").remove();
        }

        // eslint-disable-next-line no-undef
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('id', 'recaptcha');
        recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${googleRecaptchaKey}`)
        // eslint-disable-next-line no-undef
        document.head.appendChild(recaptchaScript)
    }, [])
}
